<app-activity-edition-typology-icon [iconUrl]="iconUrl"
                                    [ariaLabel]="ariaLabel">
</app-activity-edition-typology-icon>

<div class="activity-edition-typology-bloc__content">
    <h4 class="activity-edition-typology-bloc__title">{{ label }}</h4>
    <p class="activity-edition-typology-bloc__description">{{ description }}</p>
</div>